import http from "../common/services/httpService";
import { AxiosResponse } from "axios";

import {
  InvestmentBrokerUserInputDto,
  InvestmentBrokerUserPreviewDto,
  InvestmentBrokerUserSearchResultDto,
} from "../interfaces/admin/InvestmentBrokerUser";

const apiEndpoint = "/investmentBrokerUser";

const getInvestmentBrokerUsersAsync = async (
  query: string
): Promise<AxiosResponse<Array<InvestmentBrokerUserSearchResultDto>>> => {
  return await http.get<Array<InvestmentBrokerUserSearchResultDto>>(`${apiEndpoint}?${query}`);
};

const getInvestmentBrokerUsersCountAsync = async (query: string): Promise<AxiosResponse<number>> => {
  return await http.get<number>(`${apiEndpoint}/count?${query}`);
};

const getInvestmentBrokerUserAsync = async (id: number): Promise<AxiosResponse<InvestmentBrokerUserPreviewDto>> => {
  return await http.get<InvestmentBrokerUserPreviewDto>(`${apiEndpoint}/${id}`);
};

const addInvestmentBrokerUserAsync = async (
  model: InvestmentBrokerUserInputDto
): Promise<AxiosResponse<InvestmentBrokerUserInputDto>> => {
  return await http.post<InvestmentBrokerUserInputDto>(apiEndpoint, model);
};

const updateInvestmentBrokerUserAsync = async (
  model: InvestmentBrokerUserInputDto
): Promise<AxiosResponse<InvestmentBrokerUserInputDto>> => {
  return await http.put<InvestmentBrokerUserInputDto>(`${apiEndpoint}/${model.investmentBrokerUserId}`, model);
};

export default {
  getInvestmentBrokerUsersAsync,
  getInvestmentBrokerUsersCountAsync,
  getInvestmentBrokerUserAsync,
  addInvestmentBrokerUserAsync,
  updateInvestmentBrokerUserAsync,
};
